import {
  LoyaltyConfig,
  RankBody,
  ResponseList,
  RewardHistoryBody,
  UserLoyaltyInfo,
} from 'api/v1/loaylty'

export enum RankType {
  all,
  day,
}

export interface LoayltyState {
  rankType: RankType
  userInfo: UserLoyaltyInfo
  config: LoyaltyConfig
  allRank: ResponseList<RankBody[]>
  dayRank: ResponseList<RankBody[]>
  rewardHistory: ResponseList<RewardHistoryBody[]>
}
